import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomCircularProgressFullScreen } from "../../../components/CustomCircularProgress";
import useGetReversalForms from "../../../hooks/reversal/useGetFormImage"; // Atualize para o seu hook correspondente
import { Button, Chip, IconButton, List, ListItem, ListItemText } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import useGetBase64 from "../../../hooks/reversal/useGetBase64";
import { SupportAgent } from "@mui/icons-material";

const ReversalForm = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { data, isLoading } = useGetReversalForms(state.id);
  const {getData64} = useGetBase64() // Atualize para o seu hook correspondente
  const handleDownload = (idCase: string, fileName: string) => {
     getData64(idCase, fileName).then((resp: any) => {
      if(resp.status === 200) {
         const link = document.createElement('a');
          link.href = `data:application/octet-stream;base64,${resp?.data.fileBytesBase64}`;
          link.download = resp.data.attachmentFileName;
          link.click();
      }
     
    })
    
  };
  return isLoading ? (
    <CustomCircularProgressFullScreen />
  ) : (
    <Grid container spacing={2}>
       <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip icon={<SupportAgent color="error" />} label={"Formulário de Estorno"} />
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Button onClick={() => navigate(-1)}>Voltar</Button>
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <List>
          {data?.map((item:any, index:any) => (
            <ListItem key={index}>
              <ListItemText primary={item.attachmentFileName} />
              <IconButton
                aria-label="download"
                onClick={() => handleDownload(item.caseId, item.attachmentIdEncrypted)}
              >
                <FileDownloadIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Grid>
    </Grid>
  );
};

export default ReversalForm;
